import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "main" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "vip",
    class: "vip"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "img",
      src: "https://qnui.xfarmer.com/xfarmer-ui/H5Vip/vip1-1.png"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "img",
      src: "https://qnui.xfarmer.com/xfarmer-ui/H5Vip/vip2.png"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "img",
      src: "https://qnui.xfarmer.com/xfarmer-ui/H5Vip/vip3.png"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "img",
      src: "https://qnui.xfarmer.com/xfarmer-ui/H5Vip/vip1-2.png"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    id: "svip",
    class: "translate"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "img",
      src: "https://qnui.xfarmer.com/xfarmer-ui/H5Vip/svip2-1.png"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "img",
      src: "https://qnui.xfarmer.com/xfarmer-ui/H5Vip/svip2.png"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "img",
      src: "https://qnui.xfarmer.com/xfarmer-ui/H5Vip/svip3.png"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "img",
      src: "https://qnui.xfarmer.com/xfarmer-ui/H5Vip/svip2-2.png"
    })
  ])
], -1)

import { postJumpMiniProgramApi1, postJumpMiniProgramApi2 } from "../../../../api/user";
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = ref({
	id: "",
	vipId: "",//会员类型
	type: "",//从哪个端来
	isReady: false
})

const route = useRoute()
const router = useRouter()

let setRootRem = () => {
	console.log("router.currentRoute.value.query.id", router.currentRoute.value.query.id);
	state.value.vipId = router.currentRoute.value.query.id + ""
	state.value.type = router.currentRoute.value.query.type + ""
	changeFunc(state.value.vipId)
	const root = document.documentElement;
	/** 以iPhone6为例：布局视口为375px，我们把它分成10份，则1rem = 37.5px，
	 * 这时UI给定一个元素的宽为375px（设备独立像素），
	 * 我们只需要将它设置为375 / 37.5 = 10rem。
	 */
	const scale = root.clientWidth / 10;
	root.style.fontSize = scale + "px";
};
/* 会员改变 */
let changeFunc = (flag: string) => {
	let vip: any = document.getElementById("vip");
	let svip: any = document.getElementById("svip");
	let btn: any = document.getElementById("btn");
	if (flag == '2') {
		vip.className = "translate";
		svip.className = "vip";
		btn.innerText = "超级会员申请";
	} else {
		vip.className = "vip";
		svip.className = "translate";
		btn.innerText = "普通会员申请";
	}
};
const applyForVip = function () {
	let timestamp = new Date().getTime()
	let data = {
		appId: "wx7ca1d2c2fd2c0f6e",
		id: state.value.id,
		clickUrlTime: timestampToTime(timestamp),
		path: "/userCenter/vip/vip"
	}
	postJumpMiniProgramApi2(data).then((res: any) => {
		window.location.href = res.data.data
	})

};
const postJumpMiniProgram1 = () => {
	let timestamp = new Date().getTime()
	postJumpMiniProgramApi1(timestampToTime(timestamp), state.value.type).then((res: any) => {
		state.value.id = res.data.data
	})
}
function timestampToTime(timestamp: number) {
	var date = new Date(timestamp);
	var Y = date.getFullYear() + '-';
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
	var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
	var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
	return Y + M + D + h + m + s;
}
onMounted(() => {
	setRootRem()
	postJumpMiniProgram1()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", { class: "foot" }, [
      _createElementVNode("div", {
        id: "btn",
        class: "btn",
        onClick: applyForVip
      }, "普通会员申请")
    ])
  ], 64))
}
}

})